export * from "./productCategoryDetail"
export { default } from "./productCategoryDetail"
